import _ from "lodash";
import {
  Component,
} from "react";
import {
  renderChildren,
  withLocation,
} from "CommonCore/router-util";
import {
  Alert,
  Button,
  Col,
  Container,
  Form,
  FormControl,
  FormLabel,
  FormText,
  Modal,
  Row,
} from "react-bootstrap";
import MultiSelect from "react-select";
import Select from "App/legacy/react-select-virtualized";
import numeral from "numeral";

import {
  injectFunction,
  injectGenerator,
} from "CommonCore/schema-util";

import {
  Awesome,
  Checkbox,
  CustomDatePicker,
  formatValue,
  Panel,
  Radio,
  SchemaHeader,
  Spinner,
} from "CommonComponents/bricks";
import {
  LocaleNumberFormat,
} from "CommonCore/l10n";
import {
  MarkdownEditor,
  MarkdownHelpButton,
} from "CommonComponents/markdown-editor";
import {
  regExp,
} from "CommonCore/util";

export const LeftColWidth = 4, RightColWidth = 8, DatePickerColWidth = 5;

export function requiredClass(schema, entity) {
  return (_.isFunction(schema.required) ? schema.required(entity) : schema.required) ? { className: "required" } : {};
}

export function maxLengthClass(schema) {
  return schema.maxlength < 10 ? { className: "short-input" } : {};
}

export function prepareChoices(schema, entity, injects) {
  let { choices } = schema;
  const { inject } = schema;
  if (_.isFunction(choices)) {
    choices = injectGenerator(choices, inject, injects);
  }
  if (_.isFunction(choices)) {
    choices = choices(entity);
  }

    /*
     * verhindern, dass leere label übergeben werden, da dies zum Absturz führt
     * das Schema selber sollte aber eigentlich darauf achten
     */
  choices = choices && choices.filter(choice => !!choice.label);
  return schema.noSort ? choices : _.sortBy(choices, "label");
}

function applySchemaOrder(schema, array) {
  const { orderBy } = schema;
  if (orderBy) {
    const [predicates, order] = _.zip.apply(_, _.isArray(orderBy[0]) ? orderBy : [orderBy]);
    array = _.orderBy(array, predicates, order);
  }
  return array;
}

function isNumberSchema(schema) {
  return (schema.type === "number" || schema.type === "money");
}

export class ChangeOnBlurFormControl extends Component {
  constructor() {
    super();
    this.state = {};
  }

  get initialValue() {
    const { schema, entity } = this.props;
    const val = entity[schema.field];
    return isNumberSchema(schema) && !_.isEmpty(val)
            ? numeral(parseFloat(val)).format(schema.numeralFormat || LocaleNumberFormat)
            : val;
  }

  render() {
    const { schema, id } = this.props;
    const as = schema.type === "textarea" ? "textarea" : undefined;

    return <FormControl
      id={id}
      value={!_.isUndefined(this.state.value) ? this.state.value : this.initialValue || ""}
      as={as}
      maxLength={schema.maxlength}
      onChange={this.onChange}
      onBlur={this.onBlur}
      onKeyPress={this.onKeyPress}
      autoFocus={schema.autofocus} // 22.03.2017 TH: autofocus aus Schema übernehmen
      rows={schema.rows}
      type={schema.type === "password" ? schema.type : "undefined"}
      placeholder={schema.hint}
    />;
  }

  onChange = evt => {
    this.setState({ value: evt.target.value });
  };

  onKeyPress = evt => {
    if (evt.which == 13 || evt.keyCode == 13) {
      this.onBlur();
    }
  };

  onBlur = () => {
    const { value } = this.state;
    if (!_.isUndefined(value) && value != this.initialValue) {
      const { schema, onChange } = this.props;
      onChange(schema, isNumberSchema(schema) && !_.isEmpty(value) ? numeral(value).value() : value);
    }
    this.setState({ value: undefined });
  };
}

export class ChangeOnTypeFormControl extends Component {
    // Control, die während des Tippens ihren Wert meldet (im Gegensatz zu ChangeOnBlurFormControl, die dies erst beim Verlassen tut)
  constructor() {
    super();
    this.state = {};
  }

  get initialValue() {
    const { schema, entity } = this.props;
    const val = entity[schema.field];
    return isNumberSchema(schema) && !_.isEmpty(val)
            ? numeral(parseFloat(val)).format(schema.numeralFormat || LocaleNumberFormat)
            : val;
  }

  render() {
    const { schema, id } = this.props;
    const as = schema.type === "textarea" ? "textarea" : undefined;

    return <FormControl
      id={id}
      value={!_.isUndefined(this.state.value) ? this.state.value : this.initialValue || ""}
      as={as}
      maxLength={schema.maxlength}
      onChange={this.onChange}
      onKeyPress={this.onKeyPress}
      autoFocus={schema.autofocus} // 22.03.2017 TH: autofocus aus Schema übernehmen
      rows={schema.rows}
      type={schema.type === "password" ? schema.type : "undefined"}
      placeholder={schema.hint}
    />;
  }

  onChange = evt => {
    this.setState({ value: evt.target.value }, () => this.onCommit());
  };

  onKeyPress = evt => {
    if (evt.which == 13 || evt.keyCode == 13) {
      this.onCommit();
    }
  };

  onCommit = () => {
    const { value } = this.state;
    if (!_.isUndefined(value) && value != this.initialValue) {
      const { schema, onChange } = this.props;
      onChange(schema, isNumberSchema(schema) && !_.isEmpty(value) ? numeral(value).value() : value);
    }
    this.setState({ value: undefined });
  };
}

export const ControlGenerators = {
  select: function({ schema, message, entity, injects, onChange, key, leftCol, rightCol }) {
    const choices = prepareChoices(schema, entity, injects);

    // virtualized-select does not support multi mode yet, so we use the standard one for now
    const isMulti = schema.options && schema.options.isMulti;
    const SelectClass = isMulti ? MultiSelect : Select;
    const selectValue = isMulti
      ? (entity[schema.field] || [])
      : (choices.find(({ value }) => value === entity[schema.field]) || null);

    const formatOptionLabel = ({ label }) => (
      <div className='ellipsed-text'>{label}</div>
    );

    const filterOption = (option, inputValue) => {
      const { label } = option;
      const reg = regExp(inputValue, "i");
      return label.match(reg);
    };

    return <Row data-test={schema.field} key={key || schema.field} className={schema.className + message ? " has-error" : ""}>
      {!schema.hideLabel && <Col as={FormLabel} sm={leftCol || LeftColWidth}><SchemaHeader {..._.assign(schema, { entity })} /></Col>}
      <Form.Group as={Col} sm={rightCol || RightColWidth} {...requiredClass(schema, entity)}>
        <SelectClass
          value={selectValue}
          onChange={val => onChange(schema, val && val.hasOwnProperty("value") ? val.value : val)}
          options={choices}
          menuPlacement={schema.droprichtung}
          formatOptionLabel={formatOptionLabel}
          isClearable={!(schema.required && schema.default)}
          filterOption={filterOption}
          {...(schema.options || {})}
        />
        {schema.helpText && <FormText>
          {_.isFunction(schema.helpText) ? schema.helpText(entity[schema.field]) : schema.helpText}
        </FormText>}
        {message && <FormText>{message}</FormText>}
      </Form.Group>
    </Row>;
  },
  multiselect: function({ schema, message, entity, injects, onChange, key, parentIndex }) {
    const choices = prepareChoices(schema, entity, injects);
    const values = entity[schema.field];

    function toggle(value) {
      const i = values && values.indexOf(value);
      const newValues = _.clone(values) || [];
      if (!_.isNumber(i) || i === -1) {
        newValues.push(value);
      } else {
        newValues.splice(i, 1);
      }
      return newValues;
    }

    return <Row key={key || schema.field} className={schema.className}>
      <Col sm={LeftColWidth} htmlFor={schema && schema.field ? schema.field : "multiselect"} as={FormLabel}><SchemaHeader {...schema} /></Col>
      <Col sm={RightColWidth}>
        {choices.map(item => <Checkbox
          key={item.value}
          label={item.label}
          disabled={item.disabled}
          parentIndex={parentIndex}
          checked={(values && values.indexOf(item.value) !== -1) || false}
          onChange={() => onChange(schema, toggle(item.value))} />)}
        {schema.helpText && <FormText>{schema.helpText}</FormText>}
        {message && <FormText>{message}</FormText>}
      </Col>
    </Row>;
  },
  radio: function({ schema, message, entity, injects, onChange, key }) {
    const choices = prepareChoices(schema, entity, injects);
    const value = entity[schema.field];

    return <Row key={key || schema.field} className={schema.className + message ? " has-error" : ""}>
      <Col sm={LeftColWidth} htmlFor={schema && schema.field ? "radio" + schema.field : "radio"} as={FormLabel}><SchemaHeader {...schema} /></Col>
      <Col sm={RightColWidth} {...requiredClass(schema, entity)}>
        {choices.map(item => <Radio
          key={item.value}
          label={item.label}
          name={"radio" + schema.field}
          disabled={item.disabled}
          checked={(value === item.value) || false}
          onChange={() => onChange(schema, item.value)} />)}
        {schema.helpText && <FormText>{schema.helpText}</FormText>}
        {message && <FormText>{message}</FormText>}
      </Col>
    </Row>;
  },
  array: function({ schema, message, entity, injects, onChange, key, propertyPath, errorLookup }) {
    const array = entity[schema.field] || [];

    function generateSubfield(item, subentity, i) {
      return generateControl({
        schema: item,
        entity: subentity,
        injects,
        key: `${ item.field }-${ i }`,
        onChange: (s, val) => {
          const copy = _.cloneDeep(array);
          copy[i][item.field] = val;
          onChange(schema, copy);
        },
        errorLookup,
        propertyPath: `${ propertyPath }[${ i }]`,
        parentIndex: i,
      });
    }

    function add() {
      const copy = _.cloneDeep(array);
      const elem = schema.makeNewItem ? schema.makeNewItem(copy) : {};
      copy.push(elem);
      onChange(schema, copy);
    }

    function del(i) {
      const copy = _.cloneDeep(array);
      copy.splice(i, 1);
      onChange(schema, copy);
    }

    const Container = schema.header ? Panel : "div";
    const containerProps = {};
    if (schema.header) {
      containerProps.header = <SchemaHeader useHeader {...schema} />;
    }

    const ItemContainer = schema.itemHeader ? Panel : "div";
    const itemContainerProps = {
      style: { position: "relative" },
    };
    if (schema.itemHeader) {
      itemContainerProps.header = schema.itemHeader;
    }

    return <Container key={key || schema.field} {...containerProps}>
      {array.map((subentity, i) => <ItemContainer key={i} {...itemContainerProps}>
        {i != 0 && !schema.itemHeader && <hr style={{ margin: "0 0 0.6em" }} />}
        {schema.items.map(item => generateSubfield(item, subentity, i))}
        <a className='row-delete-btn' onClick={() => del(i)}><Awesome name='times' /></a>
        <RequiredFieldsHint fields={schema.items} />
      </ItemContainer>)}
      <Button variant='info' onClick={add}>
        <Awesome name='plus' />&nbsp;{schema.addText || "Hinzufügen"}
      </Button>
      {message && <Alert variant='danger'>{message}</Alert>}
      <hr />
    </Container>;
  },
  date: function({ schema, message, entity, onChange, key }) {
    const value = entity[schema.field];

    return <Row key={key || schema.field} className={schema.className + message ? " has-error" : ""}>
      <Col as={FormLabel} htmlFor={schema && schema.field ? schema.field : "date"} sm={LeftColWidth}><SchemaHeader {...Object.assign(schema, { entity })} /></Col>
      <Col sm={DatePickerColWidth} {...requiredClass(schema, entity)}>
        <CustomDatePicker
          value={value}
          id={schema && schema.field ? schema.field : "date"}
          onChange={dateString => onChange(schema, dateString)}
          isClearable={!(schema.required && schema.default)}
          name={"dateinput-" + schema.field} />
        {schema.helpText && <FormText>{schema.helpText}</FormText>}
        {message && <FormText>{message}</FormText>}
      </Col>
    </Row>;
  },
  month: function({ schema, message, entity, onChange, key }) {
    const value = _.isFunction(schema.getValue) ? schema.getValue(entity) : entity[schema.field];

    return <Row key={key || schema.field} className={schema.className + message ? " has-error" : ""}>
      <Col as={FormLabel} htmlFor={schema && schema.field ? schema.field : "date"} sm={LeftColWidth}><SchemaHeader {...schema} /></Col>
      <Col sm={DatePickerColWidth} {...requiredClass(schema, entity)}>
        <CustomDatePicker
          value={value}
          id={schema && schema.field ? schema.field : "date"}
          onChange={dateString => onChange(schema, dateString)}
          isClearable={!(schema.required && schema.default)}
          isMonthPicker
          name={"dateinput-" + schema.field} />
        {schema.helpText && <FormText>{schema.helpText}</FormText>}
        {message && <FormText>{message}</FormText>}
      </Col>
    </Row>;
  },
  checkbox: function({ schema, message, entity, onChange, key }) {
    return <Row key={key || schema.field} className={schema.className + message ? " has-error" : ""}>
      <Col sm={LeftColWidth} />
      <Col sm={RightColWidth}>
        <Checkbox
          label={<SchemaHeader {...schema} />}
          id={schema.display}
          checked={entity[schema.field] || false}
          onChange={evt => onChange(schema, evt.target.checked)}
          autoFocus={schema.autofocus} />
        {schema.helpText && <FormText>{schema.helpText}</FormText>}
        {message && <FormText>{message}</FormText>}
      </Col>
    </Row>;
  },
  readonly: function({ schema, entity, injects, key }) {
    return <Row key={key || schema.field} className={schema.className}>
      <Col as={FormLabel} htmlFor={schema && schema.field ? schema.field : "readonly"} sm={LeftColWidth}><SchemaHeader useHeader {...schema} /></Col>
      <Col sm={RightColWidth} className={`readonly-field ${ schema.className || "" }`}>
        {formatValue(entity, schema, null, injects)}
      </Col>
    </Row>;
  },
  markdown: function({ schema, message, entity, onChange, key }) {
    return <Row key={key || schema.field} className={schema.className + message ? " has-error" : ""}>
      <Col as={FormLabel} htmlFor={schema && schema.field ? schema.field : "markdown"} sm={LeftColWidth}><SchemaHeader useHeader {...schema} /></Col>
      <Col sm={RightColWidth} {...requiredClass(schema, entity)}>
        <div className='float-end'><MarkdownHelpButton /></div>
        <MarkdownEditor
          previewClassName='markdown-input-preview'
          value={entity[schema.field]}
          onChange={evt => onChange(schema, evt.target.value)}
        />
        {schema.helpText && <FormText>{schema.helpText}</FormText>}
        {message && <FormText>{message}</FormText>}
      </Col>
    </Row>;
  },
  default: function({ schema, message, entity, onChange, key, leftCol, rightCol }) {
    let className = (requiredClass(schema, entity)?.className + " ") || "";
    className += maxLengthClass(schema)?.className || "";
    return <Row key={key || schema.field} className={schema.className + message ? " has-error" : ""}>
      <Col as={FormLabel} htmlFor={schema && schema.field ? schema.field : "default"} sm={leftCol || LeftColWidth}><SchemaHeader {...Object.assign(schema, entity)} /></Col>
      <Col sm={rightCol || RightColWidth} className={className}>
        <ChangeOnBlurFormControl
          id={schema && schema.field ? schema.field : "text"}
          entity={entity}
          schema={schema}
          onChange={onChange}
        />
        {schema.helpText && <FormText>
          {_.isFunction(schema.helpText) ? schema.helpText(entity[schema.field]) : schema.helpText}
        </FormText>}
        {message && <FormText>{message}</FormText>}
      </Col>
    </Row>;
  },
};

export function generateControl(generatorArgs, customControlGenerators) {
  const { schema, entity, injects, errorLookup, propertyPath } = generatorArgs;
  if (schema.shouldShow && !schema.shouldShow(entity)) {
    return;
  }

  const readonlyGenerator = injectFunction(schema.readonly, injects);
  const isReadonly = _.isFunction(readonlyGenerator) ? readonlyGenerator(entity) : schema.readonly;

  const generator = isReadonly
    ? ControlGenerators.readonly
    : (customControlGenerators && customControlGenerators[schema.control || schema.type]) || ControlGenerators[schema.type] || ControlGenerators.default;
  const myPropertyPath = propertyPath ? `${ propertyPath }.${ schema.field }` : schema.field;

  const err = errorLookup && errorLookup[myPropertyPath];
  let message;
  if (_.isString(err)) {
    message = _.template(err, { interpolate: /{([\s\S]+?)}/g })({ attribut: schema.display });
  }
  return generator(_.assign({}, generatorArgs, {
    propertyPath: myPropertyPath,
    message,
    errorLookup, // 16.08.2017 TH: pass errorLookup for subitems
  }));
}

const RequiredFieldsHint = ({ fields }) => _.some(fields, f => f.required)
        ? <Row>
          <Col sm={LeftColWidth} />
          <Col sm={RightColWidth} className='required' style={{ paddingTop: "5px" }}>Pflichtfelder</Col>
        </Row>
        : null;

export class DetailEditor extends Component {
  render() {
    const {
      entity,
      header,
      inflight,
      injects,
      modal,
      modalBackdrop,
      onClose,
      schema,
      submitText = "Speichern",
      validationErrors,
      validationMessage,
    } = this.props;

    let {
      disableSubmit,
    } = this.props;

    disableSubmit = disableSubmit || inflight;
    let errorLookup;

    if (validationErrors) {
      const groupedErrors = _.groupBy(validationErrors, "attribut");
      errorLookup = _.mapValues(groupedErrors, arr => _.map(arr, r => r.nachricht).join("\n\n"));
    }

    const bodyHeader = validationMessage && <Alert variant='danger'>{validationMessage}</Alert>;
    const body = schema.table.filter(s => !s.specialEditor
            && (!s.hideFromEditor || !injectFunction(s.hideFromEditor, injects)(entity, { readonly: false })))
      .map(s => this.getFormControl(s, errorLookup));

    const hasSelects = _.some(schema.table, s => s.type === "select");

    const cancelButton = <Button variant='link' onClick={onClose}>Abbrechen</Button>;
    const submitButtonContent = inflight ? <Spinner /> : submitText;

    if (modal) {
      return <Modal show onHide={onClose} backdrop={modalBackdrop} keyboard={!hasSelects}>
        <Modal.Header>
          {header}
        </Modal.Header>
        <Modal.Body>
          <Form className='form-horizontal' onSubmit={this.save}>
            {bodyHeader}
            {body}
            {renderChildren(this.props)}
            <RequiredFieldsHint fields={schema.table} />
            <Button type='submit' style={{ display: "none" }} disabled={disableSubmit} />
          </Form>
        </Modal.Body>
        <Modal.Footer>
          {_.isFunction(this.props.onSave) &&
                        <Button variant='primary' disabled={disableSubmit} onClick={this.save}>
                          {submitButtonContent}
                        </Button>
          }
          {_.isFunction(this.props.onClose) && cancelButton}
        </Modal.Footer>
      </Modal>;
    }
    return <Form className='form-horizontal'>
      {bodyHeader}
      {body}
      {renderChildren(this.props)}
      <RequiredFieldsHint fields={schema.table} />
      <div className='float-end'>
        {_.isFunction(this.props.onSave) &&
                        <Button onClick={this.save} variant='primary' disabled={disableSubmit}>
                          {submitButtonContent}
                        </Button>
        }
        {_.isFunction(this.props.onClose) && cancelButton}
      </div>
    </Form>;
  }

  save = evt => {
    evt.preventDefault();
    setTimeout(this.props.onSave);
    return false;
  };

  onChange = (schemaOrField, value) => {
    const field = _.isString(schemaOrField) || _.isArray(schemaOrField) ? schemaOrField : schemaOrField.field;
    this.props.onChange({ [field]: value });
  };

  getFormControl(schema, errorLookup) {
    const { entity, injects, customControls, leftCol, rightCol } = this.props;
    return generateControl({ schema, entity, injects, onChange: this.onChange, errorLookup, leftCol, rightCol }, customControls);
  }
}

const getHistoryEntry = (entity, schema, renderMethods, injects) => {
  if (entity.history[0].hasOwnProperty(schema.field) && entity.history[0][schema.field] != entity[schema.field]) {
    const histEntity = { [schema.field]: entity.history[0][schema.field] };
    return <span><br /><div style={{ padding: "8px", border: "1px solid", borderRadius: "4px", backgroundColor: "#fcf8e3", borderColor: "#faebcc" }}><span style={{ color: "#000" }}>vormals: {_.isEmpty(histEntity[schema.field]) ? "- leer -" : formatValue(histEntity, schema, renderMethods, injects)}</span></div></span>;
  }
};

const CommonDetailValue = ({ entity = {}, schema, renderMethods, injects }) => <Row key={schema.field} className='common-detail-row'>
  <Col xs={12} lg={4}><SchemaHeader useHeader {..._.assign(schema, { entity })} /></Col>
  <Col xs={12} lg={8} style={{ whiteSpace: "pre-wrap" }}>{formatValue(entity, schema, renderMethods, injects)}
    {entity && entity.history && getHistoryEntry(entity, schema, renderMethods, injects)}
    {entity && schema.helpTextReadonly && _.isFunction(schema.helpTextReadonly) ? schema.helpTextReadonly(entity) : schema.helpTextReadonly }
  </Col>
</Row>;

const ArrayDetailValue = ({ entity = {}, schema, renderMethods, injects }) => {
  let items = entity[schema.field];
  if (schema.filter) {
    items = injectGenerator(schema.filter.generator, schema.filter.inject, injects)(items, entity);
  }
  items = applySchemaOrder(schema, items);

  return <Row>
    <Col xs={12}>
      {_.map(items, (item, itemi) => <Panel key={itemi} header={schema.itemHeader}>
        {schema.items.filter(fieldSchema => !_.isFunction(fieldSchema.hideFromDetail) ? !fieldSchema.hideFromDetail : !injectFunction(fieldSchema.hideFromDetail, injects)(entity))
          .map(fieldSchema => <span key={fieldSchema.field}>
            <DetailValue
              injects={injects}
              renderMethods={renderMethods}
              entity={item}
              schema={fieldSchema} />
          </span>)}
      </Panel>)}
    </Col>
  </Row>;
};

export const DetailValue = props => {
  if (props.customControls && props.customControls[props.schema.type + "_view"]) {
    const generator = props.customControls[props.schema.type + "_view"];
    return generator(props);
  }

  return props.schema.type === "array"
        ? <ArrayDetailValue {...props} />
        : <CommonDetailValue {...props} />;
};

@withLocation
export class DetailView extends Component {
  render() {
    const {
      schema,
      toEdit,
      embeddedToolBar,
      entity,
      injects,
    } = this.props;

    const EmbeddedToolbar = embeddedToolBar;

    const editButton = <Button
      variant='primary' style={{
        position: "absolute",
        top: "0.7em",
        right: "1em",
      }} onClick={this.edit}>Bearbeiten</Button>;

    return <Container fluid className='detail-table' style={{ position: "relative" }}>
      {embeddedToolBar && <EmbeddedToolbar entity={this.props.entity}>{toEdit && <Button variant='primary' onClick={this.edit}>Bearbeiten</Button>}</EmbeddedToolbar>}
      {
        schema.table.filter(fieldSchema => !_.isUndefined(fieldSchema.hideFromDetail) && !_.isBoolean(fieldSchema.hideFromDetail) ? !injectFunction(fieldSchema.hideFromDetail, injects)(entity, { readonly: true }) : !fieldSchema.hideFromDetail)
          .map((fieldSchema, index) => {
            const fieldKey = fieldSchema.field || fieldSchema.display || fieldSchema.header || index;
            return <DetailValue key={fieldKey} {...this.props} schema={fieldSchema} />;
          })
      }

      {toEdit && !embeddedToolBar && editButton}


    </Container>;
  }

  edit = () => {
    const { toEdit, history } = this.props;
    history.push(toEdit);
  };
}
